import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = {
    url: String
  }

  visit(event) {
    // Don't trigger if they clicked on an actual link or button inside the row
    const clickedElement = event.target.closest('a, button')
    if (clickedElement) {
      return
    }

    visit(this.urlValue)
  }
}
